export const isEmploymentIncomeSource = (incomeSource) => incomeSource === 'employment';
export const isOtherIncomeSource = (incomeSource) => incomeSource === 'other';
// eslint-disable-next-line max-len
export const showIncomeFields = (incomeSource) => isEmploymentIncomeSource(incomeSource) || isOtherIncomeSource(incomeSource);
